export const CONVERSATION_FEEDBACK_CSS = /* css */ `
  /* ── Post-conversation feedback (under the frozen transcript) ── */
  .lk-widget-ended-strip {
    flex-shrink: 0; padding: 6px 10px;
    background: var(--wg-slot-bg); color: var(--wg-fg);
    font-size: 11px; font-weight: 500; text-align: center;
  }
  .lk-widget-feedback {
    display: flex; flex-direction: column; align-items: center;
    gap: 10px; padding: 20px 15px 10px;
    text-align: center; color: var(--wg-fg);
  }
  .lk-widget-feedback-ended {
    display: flex; flex-direction: column; align-items: center; gap: 2px;
    margin-bottom: 16px;
    font-size: 10px; line-height: 1.4; color: var(--wg-card-fg-muted);
  }
  .lk-widget-feedback-ended-icon {
    display: flex; align-items: center; justify-content: center;
    width: 30px; height: 30px; margin-bottom: 8px; border-radius: 50%;
    background: var(--wg-slot-bg); color: var(--wg-fg);
  }
  .lk-widget-feedback-q {
    max-width: 230px;
    font-size: 14px; font-weight: 600; line-height: 1.35; letter-spacing: -0.14px;
  }
  .lk-widget-feedback-q--follow-up { margin-top: 10px; max-width: 280px; }
  .lk-widget-feedback-thanks {
    margin-bottom: 6px;
    font-size: 16px; font-weight: 600; letter-spacing: -0.32px;
  }
  .lk-widget-feedback-thumbs { display: flex; gap: 8px; }
  .lk-widget-feedback-thumb {
    display: flex; align-items: center; justify-content: center;
    width: 32px; height: 32px; border-radius: 6px;
    border: 1px solid var(--wg-border); background: var(--wg-bg); color: var(--wg-fg);
    cursor: pointer; transition: background 0.15s ease, border-color 0.15s ease;
  }
  .lk-widget-feedback-thumb[aria-pressed="true"] {
    background: var(--wg-cta-bg); border-color: var(--wg-cta-bg);
  }
  .lk-widget-feedback-chips {
    display: flex; flex-wrap: wrap; justify-content: center; gap: 8px;
    max-width: 320px;
  }
  .lk-widget-feedback-chips--stacked { flex-direction: column; align-items: center; }
  .lk-widget-feedback-chip {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 7px 12px; border: none; border-radius: 9999px;
    background: var(--wg-bg-secondary); color: var(--wg-card-fg);
    font-family: inherit; font-size: 12px; font-weight: 500; line-height: 1.3;
    cursor: pointer; transition: background 0.15s ease;
  }
  .lk-widget-feedback-chip:hover { background: #E3EBE9; }
  .lk-widget-feedback-chip[aria-pressed="true"] { background: var(--wg-cta-bg); }
  .lk-widget-feedback-chip svg { flex-shrink: 0; color: var(--wg-clay); }
  .lk-widget-feedback-submit {
    margin-top: 16px; padding: 11px 22px;
    border: none; border-radius: 9999px;
    background: var(--wg-cta-bg); color: var(--wg-card-fg);
    font-family: inherit; font-size: 13px; font-weight: 600;
    cursor: pointer; transition: background 0.15s ease;
  }
  .lk-widget-feedback-submit:hover { background: var(--wg-cta-bg-hover); }
  .lk-widget-feedback-new {
    display: inline-flex; align-items: center; gap: 6px;
    margin-top: 16px; padding: 9px 16px;
    border: 1px solid var(--wg-accent); border-radius: 9999px;
    background: transparent; color: var(--wg-accent);
    font-family: inherit; font-size: 13px; font-weight: 600;
    cursor: pointer; transition: background 0.15s ease;
  }
  .lk-widget-feedback-new:hover { background: var(--wg-bg-secondary); }
`;
